import moment from 'moment'
import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import GenesisFavoriteButton from '../core/GenesisFavoriteButton'
import GenesisSongShareButton from '../core/GenesisSongShareButton'
import { getGenesisSongOwner, prettyPrintWalletAddress, userBrowser } from '../core/Utils'

const AttributeContainer: FC<any> = ({ text, style }) => {
  let attribute_text_split = text.split(': ')
  let attribute = attribute_text_split[0]
  let attribute_value = attribute_text_split[1]

  let additional_class = 'perc-bg'
  if (attribute === 'Bass') additional_class = 'bass-bg'
  else if (attribute === 'Lead') additional_class = 'lead-bg'
  else if (attribute === 'Harmony') additional_class = 'harmony-bg'

  return (
    <div
      className={
        'col-auto d-flex-column align-items-center unselectable justify-content-center text-center mx-2 mb-2 attribute-container ' +
        additional_class
      }
      style={style}
    >
      <p className="mb-0 fw-bold" style={{ fontSize: '12px' }}>
        {attribute}
      </p>
      <p className="mb-1" style={{ fontSize: '14px' }}>
        {attribute_value}
      </p>
    </div>
  )
}

export const GalleryFeatured = ({ item, initialLoad, playNextSong, playPreviousSong }) => {
  const [tempo, setTempo] = React.useState('')
  const [key, setKey] = React.useState('')
  const [showSamples, setShowSamples] = React.useState(true)
  const [songOwner, setSongOwner] = React.useState(null)
  const player = React.useRef(null)

  let token_ID = item.metadata.animation_url.split('/').pop()
  let OS_link =
    'https://opensea.io/assets/0xd614e3b775b94794ea16a7843f31a56c36edcb09/' + String(token_ID)
  let player_url = item.metadata.external_url.replace(
    'https://www.arpeggi.io',
    window.location.origin
  )

  React.useEffect(() => {
    for (let i = 0; i < item.metadata.attributes.length; i++) {
      let attribute_value = item.metadata.attributes[i].value
      if (attribute_value.startsWith('Tempo:')) setTempo(attribute_value)
      if (attribute_value.startsWith('Key:')) setKey(attribute_value)
    }
    getGenesisSongOwner(item.song).then((song_owner_data) => setSongOwner(song_owner_data))
  }, [item])

  return (
    <div className="container-fluid">
      <div
        className="row d-flex justify-content-center align-items-center"
        style={{ minHeight: '400px' }}
      >
        <div className="col-12 col-lg-5 d-flex-column justify-content-center align-items-center align-content-center">
          <div className="d-flex w-100 justify-content-center mb-3">
            <iframe
              className="align-self-center mx-auto gallery-player-embed"
              src={
                initialLoad || userBrowser() === 'safari'
                  ? player_url + '?autoplay=false'
                  : player_url + '?autoplay=true'
              }
              ref={player}
              style={{
                width: '100%',
                height:
                  player.current && !('aspect-ratio' in document.body.style)
                    ? player.current.offsetWidth
                    : 'auto',
                maxHeight: '500px',
                maxWidth: '500px',
                overflowY: 'visible',
                zIndex: 3,
                aspectRatio: '1'
              }}
            />
          </div>
          <div className="w-100 d-flex justify-content-between">
            <div className="col-2"></div>
            <div className="d-flex justify-content-center col-8">
              <button className="clear-button me-2" onClick={playPreviousSong}>
                <img src="/static/icons/chevron_left_black_24dp.svg" />
              </button>
              <a target="_blank" href={OS_link} className="gallery-os-logo">
                <img src="/static/icons/opensea_logo.svg" width="30px" className="mx-auto" />
              </a>
              <button className="clear-button ms-2" onClick={playNextSong}>
                <img src="/static/icons/chevron_right_black_24dp.svg" />
              </button>
            </div>
            <div className="d-flex justify-content-end col-2">
              <GenesisSongShareButton className="me-2" song_id={token_ID} size="30px" />
              <GenesisFavoriteButton
                className=""
                song_id={token_ID}
                favorite_count={item.favorite_count}
                height="30px"
                width="30px"
              />
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-7 ps-4">
          <p className="display-1 mb-0 pe-2" style={{ marginLeft: '-3px', height: '100%' }}>
            {item.metadata.title}
          </p>
          <Link to={'/profile/' + String(item.metadata.address) + '/'}>
            <h4 className="muted underline-on-hover align-self-end">by {item.metadata.artist}</h4>
          </Link>

          <Link to={'/profile/' + (songOwner && songOwner.owner_address) + '/'}>
            <p className="pt-2 mb-0 underline-on-hover">
              <span className="fw-bold">Owner</span>{' '}
              {songOwner &&
                (songOwner?.owner_profile?.display_name ||
                  prettyPrintWalletAddress(songOwner.owner_address))}
            </p>
          </Link>
          <p className="mb-0">
            <span className="fw-bold">Mint Date</span>{' '}
            {moment.unix(Number(item.metadata.mint_time)).format('MMMM Do, YYYY')}
          </p>
          <p className="mb-0">
            <span className="fw-bold">{key.split(': ')[0]}</span> {key.split(': ')[1]}
          </p>
          <p className="">
            <span className="fw-bold">{tempo.split(': ')[0]}</span> {tempo.split(': ')[1]}
          </p>
          {showSamples && (
            <div className="row justify-content-start">
              {item.metadata.attributes.map(
                (data, index) =>
                  data.value !== 'All Songs' &&
                  !data.value.startsWith('Artist:') &&
                  !data.value.startsWith('Tempo:') &&
                  !data.value.startsWith('Key:') && (
                    <AttributeContainer key={index} text={data.value} />
                  )
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
